import { ILatestAction } from './ILatestAction.js'

export interface IAmendment {
  congress: number
  latestAction: ILatestAction
  number: string
  purpose: string
  type: string
  updateDate: string
  url: string
}
